export default {
  LEADS_OVERVIEW: 'Leads overview',
  TOTAL_LEADS: 'Total leads',
  HOT_LEADS: 'Hot leads',
  WARM_LEADS: 'Warm leads',
  COLD_LEADS: 'Cold leads',
  NO_RECORDS_FOUND: 'No records found',
  DETAILS: 'Details',
  CATEGORY: 'Category',
  SCAN_DATE_N_TIME: 'Scan date & time',
  FILTER: 'Filter',
  ALL: 'All',
  HOT: 'Hot',
  WARM: 'Warm',
  COLD: 'Cold',
  SELECT_DATES: 'Select dates',
  SEARCH_LEADS: 'Search Leads',
  SCANNED_BY: 'Scanned by',
  FILES_INFO_SHARED: 'Files and information shared',
  IMAGES: 'Images',
  NOTE: 'Note',
  DELETED_FILE_MSG: 'This file has been deleted',
  LEAD_DETAILS: 'Lead details',
  ANONYMISE_DAYS: 'The leads details will be anonymised in {days} days.'
}
